export const API_URL = 'https://elearning-dev-api.azurewebsites.net/api'
//courses
export const GET_COURSES = `${API_URL}/Course/GetCourses`
export const GET_COURSE_BY_ID = `${API_URL}/Course/GetCourseDetails`
export const GET_COURSE_TOOLS_TOPICS = `${API_URL}/Course/GetCourseLearningToolsAndTopics`
export const GET_COURSE_PROGECTS = `${API_URL}/Course/GetCourseProjects`
export const GET_COURSE_TEACHERS = `${API_URL}/Course/GetCourseTeachers`
//FAQS
export const GET_FAQS = `${API_URL}/Faq/GetFaqs`

//PROJECTA
export const GET_PROJECTS = `${API_URL}/StudentProject/GetStudentProjects`
export const GET_PROJECT_DETAILS = `${API_URL}/StudentProject/GetStudentProjectDetail`

//Students
export const GET_STUDENTS = `${API_URL}/StudentProject/GetStudents`

//contact us
export const CONTACT_US = `${API_URL}/ContactUs/ContactUs`
export const FREE_TRIAL = `${API_URL}/ContactUs/FreeTrial`
//Testemonial
export const GET_TESTIMONIALS = `${API_URL}/Testemonial/GetTestemonials`
// enroll
export const ENROLL_CLASS = `${API_URL}/Signup/ClassEnroll`
export const CREATE_PAYPAL_PAYMENT = `${API_URL}/Payment/paypal/create-payment`
export const CREATE_STRIPE_PAYMENT = `${API_URL}/Payment/stripe/create-payment-intent`
export const CHECK_STRIPE_PAYMENT_STATUS = `${API_URL}/Payment/stripe/check-payment-status`
export const CAPTURE_PAYPAL_PAYMENT = `${API_URL}/Payment/paypal/capture-payment`
export const CANCELLED_PAYPAL_PAYMENT = `${API_URL}/Payment/paypal/cancelled`
export const PROMOTION_CODE_PAYMENT = `${API_URL}/indexes/employer-request/PromotionCodes/GetByCode`
//
export const PAYPAL_CLIENT_ID =
"AegD5vpv06JZnE6_K_x-xYjDlbOe9NSaK7HQoVDO_6t4Wv627yjLXyIhuZGEZY5fkCis01xOT9rXvRGZ";
export const STRIPE_CLIENT_KEY =
"pk_live_51MoOAoLVHlWeyxkyWSlUtgPWHL2cVdvLZOEwauGFjhixMaEjvoXdHJjbfbtRxzPy6XoWGtwiIyE3qEYGE5N7jwWA00iQN1dQZU";